import { useTranslation } from 'react-i18next';

const trustItems = [
  { key: 't1', icon: 'ri-refresh-line' },
  { key: 't2', icon: 'ri-shield-check-line' },
  { key: 't3', icon: 'ri-layout-grid-line' },
  { key: 't4', icon: 'ri-rocket-line' },
  { key: 't5', icon: 'ri-scales-line' },
  { key: 't6', icon: 'ri-star-line' },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            {t('home_trust.badge')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-4">
            {t('home_trust.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            {t('home_trust.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {trustItems.map((item) => (
            <div
              key={item.key}
              className="group bg-white border border-background-200/70 rounded-2xl p-6 md:p-8 hover:border-accent-200/70 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-5 group-hover:bg-accent-100 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {t(`home_trust.${item.key}`)}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {t(`home_trust.${item.key}d`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}